import { Modal } from "./modal";

interface YoutubeModalProps {
    isOpen: boolean;
    closeModal: () => void;
    src: string;
    title: string;
    closeIconLabel: string;
}

export const YoutubeModal = ({
    isOpen,
    closeModal,
    src,
    title,
    closeIconLabel
}: YoutubeModalProps) => {
    return (
        <Modal
            isOpen={isOpen}
            closeModal={closeModal}
            closeIconLabel={closeIconLabel}
            content={(height: string) => (
                <iframe
                    style={{ verticalAlign: "bottom" }}
                    width={"100%"}
                    height={height}
                    src={src}
                    title={title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen={true}
                    data-gtm-yt-inspected-12="true"
                />
            )}
        />
    );
};
